import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { getLocationBySlugEndpoint } from 'reservations/base/constants/endpoints';
import { DEFAULT_QUERY_OPTIONS } from 'reservations/base/constants/queryOptions';
import { REDIRECT_WITH_ACCOUNT_DETAILS } from 'reservations/base/constants/redirects';
import { buildBentoboxApiEndpoint } from 'reservations/base/helpers/buildBentoboxApiEndpoint';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';
import { restClient } from 'utility/restClient';
import type { RequestError } from 'utility/restClient';

const GetAccessTokenBySlug = z.object({
  access_token: z.string()
});
type GetAccessTokenBySlug = z.infer<typeof GetAccessTokenBySlug>;

async function fetchAccessTokenBySlug(slug: string) {
  const accessTokenEndpoint = buildBentoboxApiEndpoint(
    getLocationBySlugEndpoint(slug)
  );
  const response = await restClient.get(accessTokenEndpoint);
  try {
    return GetAccessTokenBySlug.parse(response);
  } catch (err) {
    console.error('fetchAccessTokenBySlug: ', err);
    throw err;
  }
}

function useAccessTokenBySlugQuery(slug: string) {
  const { handleNavigation } = useCustomRouter();

  return useQuery<GetAccessTokenBySlug, RequestError>({
    ...DEFAULT_QUERY_OPTIONS,
    queryKey: ['accessToken', slug],
    queryFn: () => fetchAccessTokenBySlug(slug),
    enabled: !!slug,
    meta: {
      onQueryError: () => {
        handleNavigation(REDIRECT_WITH_ACCOUNT_DETAILS);
      }
    }
  });
}

export type { GetAccessTokenBySlug };
export { useAccessTokenBySlugQuery };
